<template>
  <div class="item pb-3">
    <v-layout
      class="py-2 line-height--14"
      justify-space-between
      align-center
      style="padding: 2px 0"
    >
      <!-- 날짜 -->
      <p class="mb-0 color--gray-50 font-size--12 font-weight-bold">{{ item.date }}</p>
    </v-layout>

    <v-layout align-center class="py-1">
      <!-- 송금처 이름(상세 페이지 링크) -->
      <v-flex class="flex-grow-1" style="flex-basis: 100px">
        <router-link
          class="font-weight-medium"
          id="btn__xEupa1AnukiXBcAjeeHdHg=="
          :to="{ name: 'payments/detail', params: { uuid: item.uuid } }"
        >
          {{ item.wholesalerAccount.wholesaler.name }}
        </router-link>
      </v-flex>

      <!-- 송금 금액 -->
      <v-flex class="flex-grow-1 text-right" style="flex-basis: 130px">
        <span class="font-size--16 color--gray-100 font-weight-bold">
          {{ commaFormat(item.amount) }}원
        </span>
      </v-flex>
    </v-layout>

    <v-layout align-center class="line-height--14" style="padding: 2px 0">
      <!-- 송금처 주소 -->
      <v-flex class="flex-grow-1" style="flex-basis: 100px">
        <span class="color--gray-60 font-size--12">
          {{ item.wholesalerAccount.wholesaler.location }}
        </span>
      </v-flex>

      <v-flex class="flex-grow-1 text-right d-flex justify-end" style="flex-basis: 130px">
        <!-- 송금 진행 상태 -->
        <div :key="refreshTime" class="btn status px-1 d-inline-block" :class="statusColor">
          <span>{{ item.status | choiceName('payment-status') }}</span>
        </div>
        <!-- 취소 버튼 -->
        <v-btn
          v-if="item.status === 'pending'"
          id="btn__QaCeWf0x+UO/6J6TUi3v5Q=="
          class="ml-2 btn px-1"
          depressed
          :disabled="loading"
          :loading="loading"
          @click="cancel"
        >
          <template v-slot:loader>
            <v-progress-circular indeterminate width="1" size="14" />
          </template>
          송금 취소
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { commaFormat } from '@/filter/number'

export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState('choice', ['refreshTime']),

    statusColor() {
      if (['in_progress', 'completed'].includes(this.item?.status)) {
        return 'primary'
      }

      if (['failed', 'canceled'].includes(this.item?.status)) {
        return 'error'
      }

      return 'gray'
    },
  },
  methods: {
    ...mapActions('bnpl', ['checkBeforeOrDelete', 'deletePayment']),

    commaFormat,
    async cancel() {
      try {
        this.loading = true

        // 취소 가능 여부 확인
        const isValid = await this.checkBeforeOrDelete(this.item.uuid)
        if (!isValid) {
          return
        }

        // 취소 확인창
        const { isConfirmed } = await this.$swal.basic.confirm2({
          title: '송금 취소 안내사항',
          html: `
            <p class="default">
              등록 한 송금 요청을 취소합니다.
            </p>
          `,
          cancelButtonText: '닫기',
          confirmButtonText: '송금 취소',
        })
        if (!isConfirmed) {
          return
        }

        // 송금 취소
        await this.deletePayment(this.item)
        this.$emit('reload')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  border-bottom: 1px solid $gray-20;
  margin-bottom: 8px;
}

::v-deep .btn {
  border-radius: 6px;
  background-color: $pinkred-70 !important;
  height: 25px !important;
  min-width: 61px;
  text-align: center;

  &.status {
    user-select: none;
  }

  span {
    letter-spacing: 0;
    font-size: 12px !important;
    font-weight: bold !important;
    color: #f5f5f5;
  }

  &.status.gray {
    background-color: $gray-15 !important;
    span {
      color: $gray-70 !important;
    }
  }

  &.status.primary {
    background-color: $primary-15 !important;
    span {
      color: $primary-100 !important;
    }
  }

  &.status.error {
    background-color: $pinkred-10 !important;
    span {
      color: $pinkred-110 !important;
    }
  }
}
</style>
